import $ from '../jquery-shim.js';

// Track if dynamic menu has been initialized to prevent duplicate event handlers
let dynamicMenuInitialized = false;
// Track current menu level for animation direction
let currentMenuLevel = 1;
// Track if menu is currently initializing to prevent race conditions
let menuIsInitializing = false;
// Track accordion animations to prevent conflicts
let accordionAnimating = new Set();

export function initializeMobileMenu(language) {
  const menuTargetNode = document.querySelector('#main-menu');
  const bodyElementForMenu = document.querySelector('body');

  // make sure we actually have a main menu
  if (menuTargetNode) {
    const observerOptions = {
      attributes: true,
      attributeFilter: ['class'],
    };

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') {
          if ($(menuTargetNode).hasClass('mfp-hide')) {
            $(bodyElementForMenu).removeClass('mobile-menu-is-showing');
            $(menuTargetNode).hide();
            
            // Only clear current level for new menu
            if ($(menuTargetNode).hasClass('sh-new-menu')) {
              $("#current-level").empty();
              currentMenuLevel = 1;
              // Reset initialization flags when menu is closed
              dynamicMenuInitialized = false;
              menuIsInitializing = false;
              // Clear accordion animation tracking
              accordionAnimating.clear();
            }
          } else {
            $(bodyElementForMenu).addClass('mobile-menu-is-showing');
            $(menuTargetNode).show();
            
            // Initialize appropriate menu version with a small delay to ensure DOM is ready
            setTimeout(() => {
              if ($(menuTargetNode).hasClass('sh-new-menu')) {
                initDynamicMenuSwapper();
              } else if ($(menuTargetNode).hasClass('sh-old-menu')) {
                initOldMenuHandlers();
              }
            }, 50);
          }
        }
      });
    });

    observer.observe(menuTargetNode, observerOptions);
  }
}

// NEW MENU FUNCTIONALITY (for molassefaenger pages)
function initDynamicMenuSwapper(){
  // Prevent multiple initializations
  if (menuIsInitializing || dynamicMenuInitialized) {
    return;
  }
  
  menuIsInitializing = true;
  
  // Get the first and main menu-level where the data-level equals 1
  const menuLevel = $("#dh_main-menu-container .menu-level[data-level='1']");
  showMenuLevel(menuLevel, 1, 'initial');

  // Only add accordion toggle handler once to prevent duplicates
  if (!dynamicMenuInitialized) {
    // Remove any existing handlers first to prevent duplicates
    $( "#main-menu.sh-new-menu" ).off('click.dynamicMenu');
    
    // Handler for main item clicks (slide navigation)
    $( "#main-menu.sh-new-menu" ).on('click.dynamicMenu', '.dh_menu-item > a.main-item-link', function(event){
      event.preventDefault();

      // Find the menu-level that is a sibling immediately after this item's container
      const nextLevel = $(this).closest('.dh_menu-item').nextAll('.menu-level').first();
      
      if (nextLevel.length > 0) {
        const levelData = nextLevel.data('level');
        showMenuLevel(nextLevel, levelData, 'forward');
      } else {
        // If no nextLevel, it might be a terminal link, navigate to its href
        const href = $(this).attr('href');
        if (href && href !== '#' && href !== '') {
            window.location.href = href;
        }
      }
    });
      
    // Add back button handler
    $( "#main-menu.sh-new-menu" ).on('click.dynamicMenu', '.dh-back-button', function(event){
      event.preventDefault();
      
      const parentLevelId = $(this).data('target-level');
      const menuItem = $(`#${parentLevelId}`);
      const prevLevel = menuItem.data('level');
      
      // Find parent menu level
      showMenuLevel(menuItem, prevLevel, 'backward');
    });

    $( "#main-menu.sh-new-menu" ).on('click.dynamicMenu', '.dh-accordion-title-toggle', function(event){
      event.preventDefault();
      event.stopPropagation(); // Prevent event bubbling
      
      const contentId = $(this).data('accordion-content-id');
      const $content = $('#' + contentId);
      const $arrow = $(this).find('.accordion-arrow');
      
      // Prevent multiple clicks during animation
      if (accordionAnimating.has(contentId)) {
        return;
      }
      
      // Track animation state
      accordionAnimating.add(contentId);

      $content.slideToggle(200, function() {
        // Remove from animation tracking when complete
        accordionAnimating.delete(contentId);
      });
      
      $arrow.toggleClass('tw-rotate-180');
      $(this).toggleClass('active');
    });
    
    dynamicMenuInitialized = true;
    menuIsInitializing = false;
  }
}

function showMenuLevel(menuLevel, layer, direction = 'forward'){
  const $currentLevel = $("#current-level");
  const animationDuration = 150; // ms
  
  // Don't animate on initial load
  if (direction === 'initial') {
    $currentLevel.empty();
    $(menuLevel).clone().appendTo($currentLevel);
    currentMenuLevel = layer;
    
    $currentLevel.find(".menu-level").each(function(index) {
      if($(this).data('level') !== layer){
        $(this).hide();
      } else {
        $(this).show();
      }
    });
    return;
  }
  
  // Add CSS for animations if not already present
  if (!$('#mobile-menu-animations').length) {
    $('head').append(`
      <style id="mobile-menu-animations">
        .menu-slide-out-left {
          animation: slideOutLeft ${animationDuration}ms ease-in-out forwards;
        }
        .menu-slide-out-right {
          animation: slideOutRight ${animationDuration}ms ease-in-out forwards;
        }
        .menu-slide-in-left {
          animation: slideInLeft ${animationDuration}ms ease-in-out forwards;
        }
        .menu-slide-in-right {
          animation: slideInRight ${animationDuration}ms ease-in-out forwards;
        }
        
        @keyframes slideOutLeft {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(-100%); opacity: 0; }
        }
        
        @keyframes slideOutRight {
          from { transform: translateX(0); opacity: 1; }
          to { transform: translateX(100%); opacity: 0; }
        }
        
        @keyframes slideInLeft {
          from { transform: translateX(-100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        
        @keyframes slideInRight {
          from { transform: translateX(100%); opacity: 0; }
          to { transform: translateX(0); opacity: 1; }
        }
        
        #current-level {
          position: relative;
        }
      </style>
    `);
  }
  
  // Determine slide direction
  const slideOutClass = direction === 'forward' ? 'menu-slide-out-left' : 'menu-slide-out-right';
  const slideInClass = direction === 'forward' ? 'menu-slide-in-right' : 'menu-slide-in-left';
  
  // Animate out current content
  $currentLevel.addClass(slideOutClass);
  
  // After animation completes, replace content and animate in
  setTimeout(() => {
    $currentLevel.removeClass(slideOutClass);
    $currentLevel.empty();
    $(menuLevel).clone().appendTo($currentLevel);
    
    // Show/hide appropriate levels
    $currentLevel.find(".menu-level").each(function(index) {
      if($(this).data('level') !== layer){
        $(this).hide();
      } else {
        $(this).show();
      }
    });
    
    // Animate in new content
    $currentLevel.addClass(slideInClass);
    
    // Clean up animation class after animation completes
    setTimeout(() => {
      $currentLevel.removeClass(slideInClass);
    }, animationDuration);
    
  }, animationDuration);
  
  // Update current level tracking
  currentMenuLevel = layer;
}

// OLD MENU FUNCTIONALITY (for all other pages)
function initOldMenuHandlers() {
  // Remove any existing handlers to prevent duplicates
  $('#main-menu.sh-old-menu').off('click.oldMenu');
  
  $('#main-menu.sh-old-menu').on('click.oldMenu', '.sh_menu-item.sh_has-children > a', function (event) {
    event.preventDefault();

    const $subMenu = $(this).next('.sh_sub-menu');
    // Remove 'current-slide' from any active sub-menu
    $('.sh_sub-menu.current-slide')
      .removeClass('current-slide')
      .css('overflow', 'unset');

    // Add 'current-slide' to the clicked sub-menu
    setTimeout(() => {
      $subMenu.addClass('current-slide');
      $subMenu.css('overflow', 'unset').css('overflow', 'scroll');
    }, 50);

    $('#menu-hauptmenue-mobile').addClass('submenu-active');

    // Remove 'active' from any active sub-menu that is not a parent of the clicked sub-menu
    $('.sh_sub-menu.active')
      .not($subMenu.parents('.sh_sub-menu'))
      .animate({ left: '100%' }, 200, function () {
        $(this).removeClass('active').css('overflow', 'unset');
      });

    // If the clicked sub-menu was not already active, add 'active' class
    if (!$subMenu.hasClass('active')) {
      $subMenu
        .css('left', '100%')
        .addClass('active')
        .animate({ left: '0' }, 200);
      setTimeout(() => {
        $subMenu.css('overflow', 'unset').css('overflow', 'scroll');
      }, 50);

      // Add 'active' to all parent sub-menus
      $subMenu.parents('.sh_sub-menu').addClass('active');
    }

    // Scroll to the top of the menu
    $('#main-menu').animate(
      {
        scrollTop: 0,
      },
      0
    );

    // Add a back button to the submenu if it doesn't already exist
    if ($subMenu.children('.sh_back-button').length === 0) {
      const parentText = $subMenu
        .prev('a')
        .clone()
        .children()
        .remove()
        .end()
        .text();
      $subMenu.prepend(
        '<li class="sh_back-button"><a class="tw-px-6 tw-gap-2	tw-font-bold tw-flex tw-items-center tw-h-15 tw-bg-dh_gray tw-text-black tw-mb-9 hover:text-dh_primary"  href="#"><i class="fa-solid fa-chevron-left"></i>' +
          parentText +
          '</a></li>'
      );
    }
  });

  // Handle the back functionality
  $('#main-menu.sh-old-menu').on('click.oldMenu', '.sh_back-button > a', function (event) {
    event.preventDefault();

    const $currentMenu = $(this).closest('.sh_sub-menu');
    const $parentMenu = $currentMenu.parent().closest('.sh_sub-menu');

    // Animate the current menu out to the right
    $currentMenu.animate({ left: '100%' }, 200, function () {
      // After the animation, hide the current menu
      $currentMenu
        .removeClass('active')
        .css({ left: '100%', overflow: 'unset' });
    });

    $currentMenu.removeClass('current-slide');

    // Show the parent menu if exists
    if ($parentMenu.length) {
      $parentMenu.css({ left: '0', overflow: 'scroll' }).addClass('active');
      $parentMenu.addClass('current-slide');
    } else {
      $('#menu-hauptmenue-mobile').removeClass('submenu-active');
    }
  });
}



  